/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiChartFromJSON, ApiChartToJSON, } from './ApiChart';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
export function ApiAlertChartNotificationFromJSON(json) {
    return ApiAlertChartNotificationFromJSONTyped(json, false);
}
export function ApiAlertChartNotificationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'alertId': !exists(json, 'alertId') ? undefined : json['alertId'],
        'chart': !exists(json, 'chart') ? undefined : ApiChartFromJSON(json['chart']),
        'chartFrom': !exists(json, 'chartFrom') ? undefined : (new Date(json['chartFrom'])),
        'chartId': !exists(json, 'chartId') ? undefined : json['chartId'],
        'chartLastNDays': !exists(json, 'chartLastNDays') ? undefined : json['chartLastNDays'],
        'chartTo': !exists(json, 'chartTo') ? undefined : (new Date(json['chartTo'])),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
    };
}
export function ApiAlertChartNotificationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'alertId': value.alertId,
        'chart': ApiChartToJSON(value.chart),
        'chartFrom': value.chartFrom === undefined ? undefined : (value.chartFrom.toISOString()),
        'chartId': value.chartId,
        'chartLastNDays': value.chartLastNDays,
        'chartTo': value.chartTo === undefined ? undefined : (value.chartTo.toISOString()),
        'id': value.id,
        'message': value.message,
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
    };
}
